<div
  #wrap
  class="pc-canvas-wrap"
  [class.pc-canvas-wrap--loading]="loading"
  [class.pc-canvas-wrap--pan-ready]="spaceHeld && !isPanning"
  [class.pc-canvas-wrap--panning]="isPanning"
  (pointerdown.capture)="onWrapPointerDown($event)"
  (pointermove)="onWrapPointerMove($event)"
  (pointerup)="onWrapPointerUp($event)"
  (pointercancel)="onWrapPointerUp($event)"
>
  <div class="pc-canvas-center">
    <div
      class="pc-canvas-stage"
      [style.width.cm]="page.widthCm * displayScale"
      [style.height.cm]="page.heightCm * displayScale"
      (pointerdown)="onStageClick()"
    >
      <div
        class="pc-canvas-card"
        [style.width.cm]="page.widthCm"
        [style.height.cm]="page.heightCm"
        [style.transform]="'scale(' + displayScale + ')'"
        [style.background-color]="side.backgroundColor"
      >
        @if (side.backgroundImageUrl?.trim(); as bgUrl) {
          <div
            class="pc-canvas-card__bg"
            aria-hidden="true"
            [style.top.mm]="-page.bleedMm"
            [style.right.mm]="-page.bleedMm"
            [style.bottom.mm]="-page.bleedMm"
            [style.left.mm]="-page.bleedMm"
            [style.background-color]="side.backgroundColor"
            [style.background-image]="'url(' + bgUrl + ')'"
          ></div>
        }
        <div class="pc-canvas-card__content">
          @if (!loading) {
            @for (el of visibleElements; track el.id) {
              <app-print-card-element-layer
                [element]="el"
                [cardSide]="cardSide"
                [pageWidthCm]="page.widthCm"
                [pageHeightCm]="page.heightCm"
                [safeZoneInsetMm]="safeZoneInsetMm"
                [selected]="selectedElementId === el.id"
                [scale]="displayScale"
                [fontFamily]="fontFamily"
                [fontEpoch]="fontEpoch"
                [sampleTexts]="sampleTexts"
                (selectElement)="selectElement.emit($event)"
                (contextMenu)="elementContextMenu.emit($event)"
                (interactionStart)="onLayerInteractionStart()"
                (interactionEnd)="onLayerInteractionEnd()"
                (moveElement)="onLayerMove($event)"
                (resizeElement)="onLayerResize($event)"
                (rotateElement)="rotateElement.emit($event)"
              ></app-print-card-element-layer>
            }
          }
        </div>
      </div>
      @if (showSafeZone) {
        <div
          class="pc-safe-zone"
          aria-hidden="true"
          [style.left.%]="safeZoneBox.left"
          [style.top.%]="safeZoneBox.top"
          [style.width.%]="safeZoneBox.width"
          [style.height.%]="safeZoneBox.height"
        ></div>
      }
      @if (hasSmartGuides) {
        <div class="pc-smart-guides" aria-hidden="true">
          @for (line of smartGuides.lines; track $index) {
            @if (line.axis === "x") {
              <div
                class="pc-smart-guides__line pc-smart-guides__line--x"
                [class.pc-smart-guides__line--center]="line.kind === 'center'"
                [style.left.%]="guideX(line.positionCm)"
                [style.top.%]="guideY(line.startCm)"
                [style.height.%]="guideH(line.endCm - line.startCm)"
              ></div>
            } @else {
              <div
                class="pc-smart-guides__line pc-smart-guides__line--y"
                [class.pc-smart-guides__line--center]="line.kind === 'center'"
                [style.top.%]="guideY(line.positionCm)"
                [style.left.%]="guideX(line.startCm)"
                [style.width.%]="guideW(line.endCm - line.startCm)"
              ></div>
            }
          }
          @for (gap of smartGuides.spacings; track $index) {
            @if (gap.axis === "x") {
              <div
                class="pc-smart-guides__gap pc-smart-guides__gap--x"
                [class.pc-smart-guides__gap--equal]="gap.equal"
                [style.left.%]="guideX(gap.xCm)"
                [style.top.%]="guideY(gap.yCm)"
                [style.width.%]="guideW(gap.widthCm)"
              >
                <span class="pc-smart-guides__label">{{
                  spacingLabel(gap.sizeCm)
                }}</span>
              </div>
            } @else {
              <div
                class="pc-smart-guides__gap pc-smart-guides__gap--y"
                [class.pc-smart-guides__gap--equal]="gap.equal"
                [style.left.%]="guideX(gap.xCm)"
                [style.top.%]="guideY(gap.yCm)"
                [style.height.%]="guideH(gap.heightCm)"
              >
                <span class="pc-smart-guides__label">{{
                  spacingLabel(gap.sizeCm)
                }}</span>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
@if (loading) {
  <div class="pc-canvas-overlay" aria-busy="true">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
}
